module.exports = __webpack_public_path__ + "static/media/1_step 1.56c047f6.png";